import React, {
  useContext,
  useEffect,
} from 'react';

import { SidebarContext } from '../../../layouts/Technician';
import styles from './index.module.scss'

interface Props {
  header?: string
}

const TechnicianOrders: React.FC<Props> = (props) => {
  const { setCurrentPage } = useContext(SidebarContext)

  useEffect(() => {
    setCurrentPage('orders')
  }, []);

  return (
    <>
      <div className={styles.ordersContentContainer}>
        <div>กรุณาเลือกคำสั่งซื้อ</div>
      </div>
    </>
  )
}

export default TechnicianOrders;
